export default function(api: GlobalFetch) {
  return async function(id) {
    const subs = await api.fetch(`/api/v2/license/cancel`, {
      method: 'POST',
      body: JSON.stringify({ id_order: id }),
    })

    return await handleResponse(subs)
  }
}

export async function handleResponse(response) {
  const json = await response.json()
  return json.items
}
